import React, { useEffect, useState } from 'react';
import { Download, FileSpreadsheet, Loader2, AlertCircle } from 'lucide-react';
import { aiAgentApi } from '../../lib/aiAgentApi';

export const ReportCard = ({ job }) => {
  const [state, setState] = useState(job);

  useEffect(() => {
    if (!state || !state.job_id) return;
    if (state.status === 'completed' || state.status === 'failed') return;

    let cancelled = false;
    const poll = async () => {
      try {
        const next = await aiAgentApi.getReportJob(state.job_id);
        if (cancelled) return;
        setState((prev) => ({ ...prev, ...next }));
        if (next.status === 'pending' || next.status === 'running') {
          setTimeout(poll, 2000);
        }
      } catch (e) {
        if (!cancelled) setState((s) => ({ ...s, status: 'failed', error: 'poll_failed' }));
      }
    };
    setTimeout(poll, 1500);
    return () => { cancelled = true; };
  }, [state?.job_id]);

  if (!state) return null;
  const { status, title, download_url, row_count, error } = state;

  return (
    <div data-testid="ai-agent-report-card" className="mt-3 rounded-lg border border-slate-200 bg-white p-3 not-prose">
      <div className="flex items-center gap-2 text-sm font-medium text-slate-900">
        <FileSpreadsheet className="h-4 w-4 text-teal-700" />
        <span className="truncate">{title || 'Report'}</span>
      </div>

      {status === 'completed' && download_url && (
        <a
          data-testid="ai-agent-report-download"
          href={download_url}
          target="_blank"
          rel="noreferrer"
          className="mt-2 inline-flex items-center gap-1.5 rounded-md bg-teal-700 px-3 py-1.5 text-xs font-medium text-white hover:bg-teal-800"
        >
          <Download className="h-3.5 w-3.5" /> Download CSV{row_count != null ? ` · ${row_count} rows` : ''}
        </a>
      )}

      {(status === 'pending' || status === 'running') && (
        <div className="mt-2 inline-flex items-center gap-1.5 text-xs text-slate-500">
          <Loader2 className="h-3.5 w-3.5 animate-spin" />
          {status === 'pending' ? 'Queued…' : 'Building report…'}
        </div>
      )}

      {status === 'failed' && (
        <div className="mt-2 inline-flex items-center gap-1.5 text-xs text-rose-600">
          <AlertCircle className="h-3.5 w-3.5" />
          Couldn't finish this report{error ? ` — ${error}` : ''}.
        </div>
      )}
    </div>
  );
};

export default ReportCard;
